export default __webpack_public_path__ + "static/media/setion05_bg_m.cb8c10bc.png";